import { Children, Person } from "./persons.interface";
import { User } from "./users.interface";

export interface Card {
    id: number;
    valid: string;
    nr: number;
    layout_id: number;
    created: string;
    person: Person;
    owner: User;
    person_id: number;
    branch_id: number;
    status: number; 
    unique: number;
    code: number | string;
    endless: boolean;
    updated: string; 
    confirm_doc: string; 
    children?: Children[];
  }
  

  export interface MonthlyReportItem {
    month: string;
    count: number;
    count_all: number;
    
  }

    export interface Statistics {
    valid: number;
    printed: number;
    non_printed: number;
    inactive: number;
  }

  // Status mapper
export const CARD_STATUS_MAP: { [key: number]: string } = {
  0: "W trakcie",
  1: "Przesłana do weryfikacji",
  2: "Zweryfikowana",
  3: "Wydrukowana",
  4: "Wysłana",
  7: "Brak weryfikacji",
  8: "Anulowana przez użytkownika",
  9: "Anulowana",
  10: "Nieaktywna"
};

export const CARD_TYPE_MAP: { [key: string]: string } = {
  'CHILDREN': "Rodzic",
  'SENIOR': "Senior",
  'STUDENT': "Student",
  'CITIZEN': "Płacący podatki",
  'DEFAULT': "Domyślna"
  
};
export interface NewUserCard {
    layout_id: number;
    person_id: number; 
    branch_id?: number; 
  }